import { getDeviceType } from '#/shared/lib/helpers'
import { ApiKeysPage } from '#/views/api-keys'
import { getDefaultLayoutDynamic } from '#/widgets/layouts'

ApiKeysPage.getLayout = getDefaultLayoutDynamic(() => ({
	titlePage: 'API-ключи',
	device: typeof window === 'undefined' ? 'desktop' : getDeviceType(),
}))

export default ApiKeysPage
